import {FormField} from "grommet";
import styled from "styled-components";

const HiddenFormField = styled(FormField)`
    margin: 0;
    padding: 0;
    display: none;
    > div { border: 0 }
`;

export default HiddenFormField;
